export const MAP_KEY = 'AIzaSyCSSJo6UDSFpjMPP8rUuqA4k-6sKSsL4Bc';